import { useWatch } from "react-hook-form";
import { FormInputField } from "@/components/form/FormInputField";
import type { IssueTypeId } from "../hooks/useFeedbackForm";

const DESCRIPTION_CONFIG: Record<
  IssueTypeId,
  { label: string; placeholder: string }
> = {
  question: {
    label: "How can we help?",
    placeholder: "How can we help?",
  },
  issue: {
    label: "Describe the issue",
    placeholder:
      "Describe the issue in detail.\n1. Go to…\n2. Clicked on…\n3. Observed…",
  },
  idea: {
    label: "Your idea",
    placeholder:
      "Imagine the perfect version of this tool. What would it let you do?",
  },
};

interface FeedbackDescriptionFieldProps {
  name: string;
}

export function FeedbackDescriptionField({
  name,
}: FeedbackDescriptionFieldProps) {
  const issueType = useWatch<{ issueType: IssueTypeId }>({ name: "issueType" });

  return (
    <FormInputField
      name={name}
      {...DESCRIPTION_CONFIG[issueType]}
      multiline
      autoResize
      data-testid="feedback-description"
      inputClassName="bg-[#F9FAFB] min-h-[135px]"
    />
  );
}
